/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import ReactDOM from 'react-dom';

import RootStore from 'RootStore';
import {
    Provider,
} from 'react-redux';

import 'components/shop/styles';

import {
    setCart,
    addProduct,
    loadProducts,
} from 'components/shop/actions';

import CheckoutBarContainer from './containers/CheckoutBarContainer';
import CheckoutContainer from './containers/CheckoutContainer';

const store = RootStore.getStore();
const cachedState = window.localStorage.getItem('waterbos-cart');

if (cachedState) {
    store.dispatch(setCart(
        JSON.parse(cachedState),
    ));
}

store.subscribe(() => {
    const {
        cart,
    } = store.getState().shop;

    window.localStorage.setItem('waterbos-cart', JSON.stringify(cart));
});

[...document.querySelectorAll('[data-add-product-button]')].forEach((button) => {
    button.addEventListener('click', () => {
        const {
            productSlug,
        } = button.dataset;

        store.dispatch(addProduct(productSlug));
    });
});

const checkoutBarContainer = document.querySelector('[data-checkout-bar]');
if (checkoutBarContainer) {
    ReactDOM.render(
        <Provider store={store}>
            <CheckoutBarContainer />
        </Provider>,
        checkoutBarContainer,
    );
}

const checkoutContainer = document.querySelector('[data-checkout]');
if (checkoutContainer) {
    ReactDOM.render(
        <Provider store={store}>
            <CheckoutContainer />
        </Provider>,
        checkoutContainer,
    );
}

(async () => {
    try {
        const response = await fetch('/api/products.json');
        const json = await response.json();

        RootStore.getStore().dispatch(loadProducts(json.data));
    } catch (error) {
        // ignore
    }
})();



// WEBPACK FOOTER //
// ./resources/components/shop/index.js